module.exports = {
	"https": true,
	"ws": "data.whispeer.de",
	"wsPort": 443,
	"debug": false,
	"production": true,
	"workerScript": "assets/js/build/worker.bundle.js",
	"serviceWorker": {
		"enabled": false
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/conf/production.config.json
// module id = +070
// module chunks = 1 2 3 4 5 6 7